import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppNotifications } from './components/AppNotifications';
import { AppUpdateWatcher } from './components/AppUpdateWatcher';
import { HomePage } from './pages/Home.page';
import { CompareProducts } from './pages/CompareProducts';
import { RouteAuth } from './services/Authentication';
import { AppLayout } from './components/AppLayout';
import { Account } from './pages/Account';
import { ProductViewer } from './pages/ProductViewer';
import { Signup } from './pages/Signup';
import { Login } from './pages/Login';
import { LoginReturn } from './pages/LoginReturn';
import { ResetPassword } from './pages/ResetPassword';
import { ChangePassword } from './pages/ChangePassword';
import { EditProduct } from './pages/EditProduct';
import { CreateProduct } from './pages/CreateProduct';
import { DashBoard } from './pages/DashBoard';
import { DemoRoom } from './pages/DemoRoom';
import { clientRoutes, ecomAppUrl, ecomAppBetaUrl } from './ApiPaths';
import { UserViewer } from './pages/UserViewer';
import { LayoutViewer } from './pages/LayoutViewer';
import { PortfolioMap } from './components/PortfolioMap';
import { Datatable } from './components/Datatable';
import { Ecom } from './pages/Ecom';
import { EcomAdmin } from './pages/EcomAdmin';
import { MasterAdmin } from './pages/MasterAdmin';
import { DropshippingDemo } from './pages/DropshippingDemo';
import { SsoDemo } from './pages/SsoDemo';
import { PartnerIntegrationGuide } from './pages/PartnerIntegrationGuide';
import { NotFound } from './pages/NotFound';

const environment = import.meta.env.MODE;

export function AllRoutes() {
  return (
    <BrowserRouter>
      <AppNotifications />
      <AppUpdateWatcher />
      <AppLayout>
        <Routes>
          <Route path={clientRoutes.home} element={<HomePage />} />
          <Route path={clientRoutes.compare} element={<CompareProducts />} />
          <Route path={clientRoutes.account} element={<Account />} />
          <Route path={clientRoutes.dashboard} element={<DashBoard />} />
          <Route path={clientRoutes.product} element={<ProductViewer />} />
          <Route path={clientRoutes.layout} element={<LayoutViewer />} />
          <Route path={clientRoutes.user} element={<UserViewer />} />
          <Route path={clientRoutes.embed} element={<ProductViewer />} />
          <Route path={clientRoutes.editproduct} element={<EditProduct />} />
          <Route path={clientRoutes.createproduct} element={<CreateProduct />} />
          <Route path={clientRoutes.demoRoom} element={<DemoRoom />} />
          <Route path={clientRoutes.portfolioVerse} element={<PortfolioMap />} />
          <Route path={clientRoutes.ecom} element={<Ecom iframeUrl={ecomAppUrl} containerHeight="900px" />} />
          <Route path={clientRoutes.ecomBeta} element={<Ecom iframeUrl={ecomAppBetaUrl} containerHeight="1000px" />} />
          <Route path={clientRoutes.ecomAdmin} element={<EcomAdmin />} />
          <Route path={clientRoutes.masterAdmin} element={<MasterAdmin />} />
          <Route path={clientRoutes.dropshipping} element={<DropshippingDemo />} />
          <Route path={clientRoutes.partnerGuide} element={<PartnerIntegrationGuide />} />
          {environment !== 'production' && (
            <Route path={clientRoutes.ssoDemo} element={<SsoDemo />} />
          )}
          <Route path={clientRoutes.signup} element={<Signup />} />
          <Route path={clientRoutes.login} element={<Login />} />
          <Route path={clientRoutes.loginResetPassword} element={<ResetPassword />} />
          <Route path={clientRoutes.accountChangePassword} element={<ChangePassword />} />
          <Route path={clientRoutes.loginReturn} element={<LoginReturn />} />
          {environment !== 'production' && <Route path={'/dev'} element={<Datatable />} />}

          {RouteAuth}

          {/* Catch-all: any unknown path shows 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AppLayout>
    </BrowserRouter>
  );
}
